import { ITableAdapter } from '../../../../../../generic/universal-table/types/adapter.types'
import {
  GrowerApiRow,
  GrowerCreatePayload,
  GrowerUiRow,
  GrowerUpdatePayload,
} from '../types/growerTable.types'

export const growerTableAdapter: ITableAdapter<
  GrowerApiRow,
  GrowerUiRow,
  GrowerCreatePayload,
  GrowerUpdatePayload
> = {
  fromApi: (row: GrowerApiRow): GrowerUiRow => ({
    GrowerID: row.GrowerID,
    GrowerName: row.GrowerName?.trim() ?? '',
    AccounID: row.AccounID?.trim() ?? '',
    Active: row.Active ?? false,
    ActivityType: row.ActivityType ?? 0,
    ClientID: row.ClientID ?? 0,
    Exporter_Num: row.Exporter_Num ?? 0,
    Farm_Num: row.Farm_Num ?? 0,
    FieldMan: row.FieldMan ?? 0,
    GGN: row.GGN?.trim() ?? '',
    GroupID: row.GroupID ?? 0,
    Kanat_Num: row.Kanat_Num ?? 0,
    Muaza_Num: row.Muaza_Num?.trim() ?? '',
    Pay_Discharge: row.Pay_Discharge ?? false,
    Pay_Levies: row.Pay_Levies ?? false,
    Pay_Logistics: row.Pay_Logistics ?? false,
    Payment_Method: row.Payment_Method ?? 0,
    PickUp: row.PickUp ?? false,
  }),

  toCreatePayload: ({
    GrowerID: _,
    ...rest
  }: GrowerUiRow): GrowerCreatePayload => rest,

  toUpdatePayload: ({
    GrowerID: _,
    ...rest
  }: GrowerUiRow): GrowerUpdatePayload => rest,

  getRowId: (row: GrowerUiRow): number => row.GrowerID,
}
